import { ca } from '@cian/analytics';
import { isNewOffer } from './../ad-state.service';
import { adAnalyticsCategory } from '../analytics.service';

/**
 * @description метод трекает клик по быстрой навигации на форме подачи
 *
 * @param {string} label кликнутая ссылка
 */
export function trackNavigationClick(label) {
  ca('eventSite', {
    name: 'oldevent',
    category: adAnalyticsCategory,
    action: 'quick_scroll',
    label,
  });
}
